// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3Fhvu","cell":"ColumnAccessor_cell__3jEOc","firstCellAccent":"ColumnAccessor_firstCellAccent__10_sR"};